let resolveBootstrap

/** Resolves when releaseBootstrapGate() runs — blocks router until bootstrap finishes. */
export const bootstrapGate = new Promise((resolve) => {
  resolveBootstrap = resolve
})

export function releaseBootstrapGate () {
  if (typeof resolveBootstrap === 'function') {
    resolveBootstrap()
    resolveBootstrap = null
  }
}
